

    <h2 mat-dialog-title class="tsd-title" style="font-size: 2em;
    padding-left: 0 !important;">
    Trip Tasks
    </h2>

    <div mat-dialog-content class="tsd-content">
      <div *ngIf="data?.job" class="tsd-trip-header">
        <div class="tsd-trip-header-info">
          <strong>Trip Status:</strong>
          <span class="tsd-trip-status-text" [class.tsd-trip-status-complete]="markComplete">
            {{ markComplete ? 'Complete' : (tripStatus() || 'Unknown') }}
          </span>
        </div>
        <mat-checkbox class="tsd-complete-check" [(ngModel)]="markComplete" color="primary">
          Mark this trip complete
        </mat-checkbox>
      </div>

      <div class="tsd-header-row">
        <div class="tsd-col tsd-customer">Customer</div>
        <div class="tsd-col tsd-jobtype">Job Type</div>
        <div class="tsd-col tsd-status">Status</div>
      </div>

      <div class="tsd-row" [class.tsd-row-active]="isJobActioned(job)" *ngFor="let job of data.jobs">
        <div class="tsd-col tsd-customer">
          <span class="tsd-mobile-label">Customer:</span>
          <span class="tsd-mobile-value">{{ job.customer_name }}</span>
        </div>
        <div class="tsd-col tsd-jobtype">
          <span class="tsd-mobile-label">Job Type:</span>
          <span class="tsd-mobile-value">{{ job.customer_jobtype }}</span>
        </div>

        <div class="tsd-col tsd-status">
          <span class="tsd-mobile-label">Status:</span>
          <mat-form-field appearance="outline" class="tsd-status-field">
            <mat-select [(ngModel)]="job.job_status">
              <mat-option *ngFor="let s of statusOptions" [value]="s.value">
                {{ s.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="tsd-empty" *ngIf="!data?.jobs?.length">
        No jobs found.
      </div>

      <ng-container *ngIf="data?.pastJobs?.length">
        <h3 class="tsd-past-title">Previous Tasks at this Location (read-only)</h3>

        <div class="tsd-header-row">
          <div class="tsd-col tsd-customer">Customer</div>
          <div class="tsd-col tsd-jobtype">Job Type</div>
          <div class="tsd-col tsd-past-date">Trip Date</div>
          <div class="tsd-col tsd-past-status">Status</div>
        </div>

        <div class="tsd-row tsd-row-past" *ngFor="let past of data.pastJobs">
          <div class="tsd-col tsd-customer">
            <span class="tsd-mobile-label">Customer:</span>
            <span class="tsd-mobile-value">{{ past.customer_name }}</span>
          </div>
          <div class="tsd-col tsd-jobtype">
            <span class="tsd-mobile-label">Job Type:</span>
            <span class="tsd-mobile-value">{{ past.customer_jobtype }}</span>
          </div>
          <div class="tsd-col tsd-past-date">
            <span class="tsd-mobile-label">Trip Date:</span>
            <span class="tsd-mobile-value">{{ past.trip_date | date:'M/d/yyyy' }}</span>
          </div>
          <div class="tsd-col tsd-past-status">
            <span class="tsd-mobile-label">Status:</span>
            <span class="tsd-mobile-value">{{ past.job_status || 'No status' }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <div mat-dialog-actions align="end" class="tsd-actions">
      <button style="width:8em;" mat-stroked-button (click)="dialogRef.close(null)">Cancel</button>
      <button style="width:8em;" mat-flat-button color="primary" (click)="save()">Save</button>
    </div>


  